import { useEffect, useState } from 'react';

import moment from 'moment';
import { useSelector } from 'react-redux';
import { Link, useParams } from 'react-router-dom';
import PostingsApi from '../../../API/shipment/postings-api';
import ShipmentsApi from '../../../API/shipment/shipments-api';
import UserApi from '../../../API/user/user-api';
import excel from '../../../assets/media/icons/excel.png';
import { Column, Row, WhiteBlock } from '../../../components/Basic/Blocks';
import { Button } from '../../../components/Basic/Buttons';
import { Icon } from '../../../components/Basic/Elements';
import { Content, PageTitle } from '../../../components/Basic/Global';
import { DateInput } from '../../../components/Basic/Inputs';
import { HeaderTitle, Table, TableCell, TableHeader, TableLine } from '../../../components/Basic/Table';
import { H1, H3, Text, TextGrey } from '../../../components/Basic/WrapsStyle';
import { TO_SELLARY, TYPE_BUTTONS } from '../../../constans';
import { getDate } from '../../../utils';
import { numberWithSpaces } from '../../../utils/index';
import styles from '../../Shipments/Packaging/styles.module.scss';

export const WIDTH = [
  '200px', // 0
  '400px', // 1
];
const initToday = () => {
  return moment(new Date()).format('MM-DD-YYYY');
};

const STATUS_SELLAY_MAP = {
  new: 'Текущий период',
  closed: 'Оплачено',
};

function ProfilePage() {
  const { userId } = useParams();
  const id = userId
  const current_user = useSelector((store) => store.user);

  const [user, setUser] = useState({});
  const [date, setDate] = useState(initToday());
  const [statistic, setStatistic] = useState({});
  const [periods, setPeriods] = useState([]);

  let load = () => {
    UserApi.getUserFinances({ data: { userId: id ? id : current_user._id } })
      .then((r) => {
        setPeriods(r.userFinancePeriods);
        setUser(r.user);
      });
  };
  useEffect(() => {
    if (user.role === 'packer') {
      ShipmentsApi.getUsersStatistic({ data: { users: [user.name], date } })
        .then((r) => r.statistic)
        .then((r) => {
          setStatistic(r);

          const d = Object.keys(r || {}).map((key) => r[key]);
        })
        .catch();
    }
  }, [date, user]);

  useEffect(() => {
    load();
    console.log('id', id, id || current_user._id);
  }, [id]);

  let isOwner = user.role == 'owner' || user.role == 'admin';
  return (
    <Content>
      <PageTitle title={user.name} />
      <H1>Профиль {`${user.name}`}</H1>
      <WhiteBlock style={{ minWidth: '500px' }}>
        <Text fontSize={16}>
          <span style={{ fontWeight: '600' }}>Имя:</span> {user.name}
          <br />
          <span style={{ fontWeight: '600' }}>Login:</span> {user.login}
          <br />
          <span style={{ fontWeight: '600' }}>Роль:</span> {user.role}
        </Text>
      </WhiteBlock>

      {user.role === 'packer' && (
        <WhiteBlock style={{ width: '600px' }}>
          <H3>Данные упаковки</H3>

          <Row style={{ alignItems: 'flex-end' }}>
            <DateInput
              label="Дата упаковки"
              className={styles.date_input}
              value={date}
              width={'200px'}
              onChange={(v) => setDate(new Date(v))}
            />

            <Button
              type={TYPE_BUTTONS.WHITE}
              onClick={() =>
                PostingsApi.excelPackagersStatistic({
                  data: {
                    user: user.name,
                    period: { startDate: date, endDate: new Date().setTime(new Date(date).getTime() + 24 * 3600000) },
                  }
                })
              }
              style={{ marginLeft: '10px' }}
            >
              <Icon src={excel} width={30} />
            </Button>
          </Row>

          <Row style={{ marginTop: '20px' }}>
            <Column>
              <Row>
                <TextGrey fontSize={'30px'}>Зарплата: </TextGrey>{' '}
                <Text fontSize={'35px'} fontWeight={'600'}>
                  {((statistic[user.name] || {})?.package?.pay || 0) +
                    ((statistic[user.name] || {})?.package_fbo?.pay || 0) +
                    ((statistic[user.name] || {})?.pick?.pay || 0) +
                    ((statistic[user.name] || {})?.pick_express?.pay || 0) +
                    ((statistic[user.name] || {})?.sort?.pay || 0) +
                    ((statistic[user.name] || {})?.reserves?.sum || 0) +
                    ((statistic[user.name] || {})?.entry?.overage?.sum || 0) +
                    ((statistic[user.name] || {})?.entry?.entrying?.sum || 0) +
                    ((statistic[user.name] || {})?.entry?.return?.sum || 0)
                  }
                </Text>
              </Row>
              <Row>
                <TextGrey fontSize={'30px'}>Количество разложенных заказов: </TextGrey>{' '}
                <Text fontSize={'35px'} fontWeight={'600'}>
                  {(statistic[user.name] || {}).pick?.count}
                </Text>
              </Row>
              <Row>
                <TextGrey fontSize={'30px'}>Количество обработанных экспрессов: </TextGrey>{' '}
                <Text fontSize={'35px'} fontWeight={'600'}>
                  {(statistic[user.name] || {}).pick_express?.count || 0}
                </Text>
              </Row>
              <Row>
                <TextGrey fontSize={'30px'}>Количество упакованных заказов FBO: </TextGrey>{' '}
                <Text fontSize={'35px'} fontWeight={'600'}>
                  {(statistic[user.name] || {}).package_fbo?.count || 0}
                </Text>
              </Row>
              <Row>
                <TextGrey fontSize={'30px'}>Количество упакованных заказов: </TextGrey>{' '}
                <Text fontSize={'35px'} fontWeight={'600'}>
                  {(statistic[user.name] || {}).package?.count}
                </Text>
              </Row>
              <Row>
                <TextGrey fontSize={'30px'}>Количество отсортированных заказов: </TextGrey>{' '}
                <Text fontSize={'35px'} fontWeight={'600'}>
                  {(statistic[user.name] || {}).sort?.count}
                </Text>
              </Row>
              <Row>
                <TextGrey fontSize={'30px'}>Количество собранных резервов: </TextGrey>{' '}
                <Text fontSize={'35px'} fontWeight={'600'}>
                  {(statistic[user.name] || {}).reserves?.count}
                </Text>
              </Row>
              <Row>
                <TextGrey fontSize={'30px'}>Количество внесенных возвратов: </TextGrey>{' '}
                <Text fontSize={'35px'} fontWeight={'600'}>
                  {(statistic[user.name] || {}).entry?.return?.count || 0}
                </Text>
              </Row>
              <Row>
                <TextGrey fontSize={'30px'}>Количество внесений с отгрузки: </TextGrey>{' '}
                <Text fontSize={'35px'} fontWeight={'600'}>
                  {(statistic[user.name] || {}).entry?.overage?.count || 0}
                </Text>
              </Row>
              <Row>
                <TextGrey fontSize={'30px'}>Количество внесений от поставщика: </TextGrey>{' '}
                <Text fontSize={'35px'} fontWeight={'600'}>
                  {(statistic[user.name] || {}).entry?.entrying?.count || 0}
                </Text>
              </Row>
            </Column>
          </Row>
        </WhiteBlock>
      )}

      {true && (
        <Table styles={styles.table}>
          <TableHeader whiteHeader>
            <HeaderTitle width={WIDTH[0]} centerText={true}>
              Период
            </HeaderTitle>
            <HeaderTitle width={WIDTH[0]} centerText={true}>
              Статус
            </HeaderTitle>
            <HeaderTitle width={WIDTH[0]} centerText={true}>
              Сделка
            </HeaderTitle>
            <HeaderTitle width={WIDTH[0]} centerText={true}>
              Почасовая оплата
            </HeaderTitle>
            <HeaderTitle width={WIDTH[0]} centerText={true}>
              Штрафы
            </HeaderTitle>
            <HeaderTitle width={WIDTH[0]} centerText={true}>
              Возврат штрафов
            </HeaderTitle>
            <HeaderTitle width={WIDTH[0]} centerText={true}>
              Премия
            </HeaderTitle>
            <HeaderTitle width={WIDTH[0]} centerText={true}>
              Зарплата
            </HeaderTitle>
          </TableHeader>
          {periods.map((period) => {
            console.log(period);
            let salary = period.salary;
            let penalty = period.penalty;
            let return_penalty = period.return_penalty;
            let total = period.total;
            let premium = period.premium;

            return (
              <TableLine key={period._id}>
                <TableCell width={WIDTH[0]}>
                  <Link to={TO_SELLARY(userId, period._id)} className={styles.link}>
                    {period.status === 'new' ? (
                      <>{getDate(period.period.from)}</>
                    ) : (
                      <>
                        {getDate(period.period.from)} - {getDate(period.period.to)}
                      </>
                    )}
                  </Link>
                </TableCell>
                <TableCell width={WIDTH[0]} center>
                  {STATUS_SELLAY_MAP[period.status]}
                </TableCell>
                <TableCell width={WIDTH[0]} center>
                  <Text className={styles.green}>
                    + {numberWithSpaces(salary?.packaging?.sum + salary?.pick?.sum + salary?.pick_express?.sum + salary?.entry_return?.sum + salary?.entry_overage?.sum + salary?.entry_entrying?.sum + salary?.reserve_assembly?.sum)}
                  </Text>
                </TableCell>
                <TableCell width={WIDTH[0]} center>
                  <Text className={styles.green}>+{numberWithSpaces(Math.ceil(salary?.extra_work?.sum))}</Text>
                </TableCell>
                <TableCell width={WIDTH[0]} center>
                  <Text className={styles.red}>-{numberWithSpaces(penalty?.sum)}</Text>
                </TableCell>
                <TableCell width={WIDTH[0]} center>
                  <Text className={styles.green}>+{numberWithSpaces(return_penalty?.sum)}</Text>
                </TableCell>
                <TableCell width={WIDTH[0]} center>
                  <Text className={styles.green}>+{numberWithSpaces(Math.ceil(salary?.premium?.sum))}</Text>
                </TableCell>
                <TableCell width={WIDTH[0]} center>
                  <Text className={total > 0 ? styles.green : styles.red}>
                    {total > 0 ? '+' : ''}
                    {numberWithSpaces(total)}
                  </Text>
                </TableCell>
              </TableLine>
            );
          })}
        </Table>
      )}
    </Content>
  );
}

export default ProfilePage;
